var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-popwindow',{attrs:{"id":"pop-insert-label-dialog","title":_vm.$g('InsertLabels ')},on:{"ok":_vm.onPopSelected}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }